module.exports = require("module");


//////////////////
// WEBPACK FOOTER
// external "module"
// module id = 246
// module chunks = 0 1 2 3